import { parseISO } from "date-fns";
import { z } from "zod";

export const AppointmentFormSchema = z.object({
  formId: z.string(),
  versionId: z.string(),
  version: z.number().int().positive(),
  name: z.string(),
  sequenceOrder: z.number().int().nonnegative(),
  services: z.array(z.object({ serviceId: z.string(), name: z.string() })),
});

export const AppointmentFormDtoSchema = z.object({
  form_id: z.string(),
  version_id: z.string(),
  version: z.number().int().positive(),
  name: z.string(),
  sequence_order: z.number().int().nonnegative(),
  services: z.array(z.object({ service_id: z.string(), name: z.string() })),
});

const AppointmentFormsReviewDtoSchema = z.object({
  forms: z.array(AppointmentFormDtoSchema),
  review_token: z.string().min(1),
  forms_captured_at: z.string().nullable(),
});

export type AppointmentForm = z.infer<typeof AppointmentFormSchema>;
export type AppointmentFormDto = z.infer<typeof AppointmentFormDtoSchema>;
export type AppointmentFormsReviewDto = z.infer<typeof AppointmentFormsReviewDtoSchema>;

export function fromAppointmentFormDtoToAppointmentForm(dto: AppointmentFormDto): AppointmentForm {
  const form = AppointmentFormDtoSchema.parse(dto);
  return {
    formId: form.form_id,
    versionId: form.version_id,
    version: form.version,
    name: form.name,
    sequenceOrder: form.sequence_order,
    services: form.services.map((service) => ({ serviceId: service.service_id, name: service.name })),
  };
}

export function fromAppointmentFormsReviewDto(dto: AppointmentFormsReviewDto) {
  const review = AppointmentFormsReviewDtoSchema.parse(dto);
  return {
    forms: review.forms.map(fromAppointmentFormDtoToAppointmentForm),
    reviewToken: review.review_token,
    formsCapturedAt: review.forms_captured_at ? parseISO(review.forms_captured_at) : null,
  };
}
